<template>
  <div>
    <v-dialog v-model="isOpen" persistent max-width="700">
      <v-card class="align-center text-center">
        <v-card-text>
          <div class="pt-5 d-flex align-center justify-space-between">
            <h1>Exportar Dados</h1>
            <v-btn icon @click="close()" class="align-self-end">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
          <v-row class="pb-2 mt-5">
            <v-col cols="12" md="6">
              <v-menu
                ref="isInitialDateOpen"
                v-model="isInitialDateOpen"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formattedInitialDate"
                    label="Data Inicial"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="initialDate" locale="pt-br"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="6">
              <v-menu
                ref="isEndDateOpen"
                v-model="isEndDateOpen"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formattedEndDate"
                    label="Data Final"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="endDate" locale="pt-br"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12">
              <v-menu
                ref="isEndDateOpen"
                v-model="isHolidaysOpen"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                :close-on-content-click="false"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-combobox label="Feriados" v-on="on" v-model="holidays" multiple readonly clearable>
                    <template slot="prepend">
                      <div class="d-flex align-center" style="height: 36px">
                        <v-icon>mdi-calendar</v-icon>
                      </div>
                    </template>
                    <template slot="selection" slot-scope="data">
                      <div>
                        <v-chip close @input="onDateClick(data.item)" @click:close="onCloseClick(data.item)">
                          {{ getFormattedDate(data.item) }}
                        </v-chip>
                      </div>
                    </template>
                  </v-combobox>
                </template>
                <v-date-picker
                  locale="pt-br"
                  v-model="holidayDate"
                  no-title
                  @input="onDateClick(holidayDate)"
                  :events="holidays"
                  event-color="blue lighten-1"
                >
                  <v-spacer></v-spacer>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <div v-if="filledFiltersKeys.length" class="text-left pt-3 filters">
            <h3 class="">Filtros Aplicados</h3>
            <v-row dense class="pt-2">
              <v-col v-for="filterKey of filledFiltersKeys" :key="filterKey" cols="4">
                <div>
                  <strong style="font-weight: 600"> {{ `${filtersNameByKey[filterKey]}:` }}</strong>
                  <span>
                    {{ getFilterValueFormatted(filters[filterKey], filterKey) }}
                  </span>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between pb-5">
          <v-btn color="error" class="flex-grow-1" large @click="close"> Cancelar </v-btn>
          <v-btn
            :loading="isLoading"
            :disabled="isButtonDisabled"
            color="success"
            class="flex-grow-1"
            large
            @click="onSubmitClick()"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { formatDate } from '@/handlers/DateHandler';
import { mapActions } from 'vuex';
import { FeedbackMessageHandler } from '@/store/modules/feedbackMessageHandler';

const filtersNameByKey = {
  initialCompletionDate: 'Data de conclusão inicial',
  endCompletionDate: 'Data de conclusão final',
  initialForecastDate: 'Data de previsão inicial',
  endForecastDate: 'Data de previsão final',
  isReceiptDownloaded: 'Canhoto baixado',
  isReceiptPurged: 'Canhoto expurgado',
  initialAuthDate: 'Data inicial',
  endAuthDate: 'Data final',
  stateId: 'Estado',
  cityId: 'Cidade',
  hasReceiptFilter: 'Possui canhoto',
  isReceiptValidFilter: 'Canhoto validado',
  isTransferred: 'Transferido',
  transhipmentId: 'Transbordo',
  numberCTE: 'Número CTE',
  senderId: 'Remetente',
  recipient: 'Destinatário',
  keyNfe: 'Número NFE',
  boardingNumber: 'Número de embarque',
  courierId: 'Entregador',
  boardingId: 'Id do embarque',
  numberInvoiceId: 'Id da fatura',
  status: 'Status'
};

export default {
  props: {
    states: {
      default: () => [],
      type: Array
    },
    cities: {
      default: () => [],
      type: Array
    },
    transhipments: {
      default: () => [],
      type: Array
    },
    status: {
      default: () => [],
      type: Array
    },
    senders: {
      default: () => [],
      type: Array
    },
    couriers: {
      default: () => [],
      type: Array
    },
    isOpen: {
      default: false,
      type: Boolean
    },
    isShipper: {
      default: false,
      type: Boolean
    },
    filters: {
      default: () => ({
        initialAuthDate: null,
        endAuthDate: null,
        stateId: null,
        cityId: null,
        hasReceiptFilter: null,
        isReceiptValidFilter: null,
        isTransferred: null,
        transhipmentId: null,
        numberCTE: null,
        senderId: null,
        recipient: null,
        keyNfe: null,
        boardingNumber: null,
        courierId: null,
        boardingId: null,
        numberInvoiceId: null,
        status: null
      })
    }
  },
  data: () => ({
    isLoading: false,
    filtersNameByKey,
    holidayDate: null,
    initialDate: null,
    endDate: null,
    isInitialDateOpen: false,
    isEndDateOpen: false,
    isHolidaysOpen: false,
    holidays: []
  }),
  computed: {
    isButtonDisabled() {
      return this.initialDate === null || this.endDate === null;
    },
    filledFilters() {
      if (this.filters) {
        const arrayKeys = ['keyNfe', 'boardingNumber', 'status', 'numberCTE'];
        const hiddenFilterKeys = ['initialAuthDate', 'endAuthDate'];
        const dateKeys = ['initialCompletionDate', 'endCompletionDate', 'initialForecastDate', 'endForecastDate'];
        return Object.entries(this.filters).reduce((acc, [key, value]) => {
          if (dateKeys.includes(key) && value !== null) {
            return { ...acc, [key]: value };
          } else if (hiddenFilterKeys.includes(key)) {
            return { ...acc };
          } else if (arrayKeys.includes(key)) {
            return value.length ? { ...acc, [key]: value } : { ...acc };
          } else if (value !== null) {
            return { ...acc, [key]: value };
          }
          return { ...acc };
        }, {});
      }
      return '';
    },
    filledFiltersKeys() {
      if (this.filledFilters !== '') {
        return Object.keys(this.filledFilters);
      }
      return [];
    },
    formattedInitialDate() {
      if (!this.initialDate) return '';
      const [year, month, day] = this.initialDate.split('-');
      return `${day}/${month}/${year}`;
    },
    formattedEndDate() {
      if (!this.endDate) return '';
      const [year, month, day] = this.endDate.split('-');
      return `${day}/${month}/${year}`;
    }
  },

  watch: {
    isOpen: {
      handler(isOpen) {
        if (isOpen) {
          console.log(this.filters);
          this.initialDate = this.filters.initialAuthDate;
          this.endDate = this.filters.endAuthDate;
        }
      }
    }
  },
  methods: {
    ...mapActions('ReportStore', ['report', 'getReports']),
    async onSubmitClick() {
      try {
        this.isLoading = true;
        const payload = {
          isShipper: this.isShipper,
          filters: this.filters,
          body: {
            initialDate: this.initialDate,
            dateEnd: this.endDate,
            holidays: this.holidays
          }
        };
        const response = await this.report(payload);
        if (response.success) {
          this.close();
          FeedbackMessageHandler.setFeedbackMessage(this, 'Dados reportados com sucesso!');
          if (this.isShipper) {
            this.$router.push('shipper-deliveries-export');
          } else {
            this.$router.push('shipments/export');
          }
        } else {
          this.$emit('errorOnExport', { errors: response.errors, errorsType: 'error' });
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    getFilterValueFormatted(filterValue, filterKey) {
      const dateKeys = ['initialCompletionDate', 'endCompletionDate', 'initialForecastDate', 'endForecastDate'];
      if (filterKey === 'courierId') {
        return this.couriers.find((courier) => courier.id === filterValue).name;
      } else if (filterKey === 'status') {
        return filterValue.map((statusId) => this.status.find((status) => status.id === statusId).name).join(', ');
      } else if (filterKey === 'stateId') {
        return this.states.find((state) => state.id === filterValue).name;
      } else if (filterKey === 'senderId') {
        return this.senders.find((sender) => sender.id === filterValue).name;
      } else if (filterKey === 'cityId') {
        return this.cities.find((city) => city.id === filterValue).name;
      } else if (filterKey === 'transhipmentId') {
        return this.transhipments.find((transhipment) => transhipment.id === filterValue).name;
      } else if (filterValue === true || filterValue === false) {
        return filterValue ? 'Sim' : 'Não';
      } else if (Array.isArray(filterValue)) {
        return filterValue.join(', ');
      } else if (dateKeys.includes(filterKey)) {
        return new Date(filterValue).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
      }
      return filterValue;
    },
    onDateClick(date) {
      var index = this.holidays.findIndex((x) => x === date);

      if (index === -1) {
        this.holidays.push(date);
      } else {
        this.holidays.splice(index, 1);
      }
    },
    getFormattedDate(dt_string) {
      return formatDate(dt_string);
    },
    onCloseClick(date) {
      const index = this.holidays.indexOf(date);
      this.holidays.splice(index, 1);
    },
    close() {
      this.$emit('update:isOpen', false);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-select__selections {
  padding-left: 35px !important;
}
.filters {
  h3 {
    color: #0f416e;
    font-size: 16px;
    font-weight: 600;
  }
}
</style>
